import React, { PureComponent } from 'react';
import { Popover, Select, SelectProps } from 'antd';
import { isExpired } from '../utils';
import { CheckOutlined, CloseOutlined, DownOutlined } from '@ant-design/icons';
import { BaseInputProps } from '../types';
import classNames from 'classnames';

export interface ExpiriesProps extends BaseInputProps {
  value?: string[];

  onChange?(val: string[]): void;

  /**
   * @default true
   * */
  multiple?: boolean;
  options?: string[];
  calcDisabled?(option: string): boolean;
  className?: string;
}

export class Expiries extends PureComponent<ExpiriesProps> {
  state = { visible: false };

  handleVisibleChange = (visible: boolean) => this.setState({ visible });

  onChange = (val: string | string[]) => {
    let value = [...(this.props.value?.filter((item) => this.props.options?.includes(item)) || [])];

    if (this.props.multiple !== false || Array.isArray(val)) {
      value = val as string[];
    } else {
      value = [val];
    }

    this.props.onChange?.(value);
    this.props.onBlur?.();

    if (this.props.multiple === false) this.handleVisibleChange(false);
  };

  renderValue() {
    const value = this.props.value?.filter((it) => it && !isExpired(it));
    if (this.props.readonly) {
      return <span className="param-expiries-val">{value?.join(', ') || '-'}</span>;
    }
    const placeholder = <span className="param-expiries-placeholder">Choose</span>;
    if (this.props.multiple === false) {
      const val = this.props.value?.[0];
      return !val || isExpired(val) ? (
        placeholder
      ) : (
        <span className="param-expiries-val">{val}</span>
      );
    }
    if (!value?.length) return placeholder;
    return value.map((it) => (
      <span className="param-expiries-multi-val" key={it} onClick={(e) => e.stopPropagation()}>
        {it}
        <CloseOutlined onClick={this.onChange.bind(null, it)} />
      </span>
    ));
  }

  render() {
    const options: SelectProps['options'] = [];    

    for (let i = 0; i < 100000; i++) {
      const value = `${i.toString(36)}${i}`;
      options.push({
        label: value,
        value,
        disabled: i === 10,
      });
    }

    return this.props.readonly ? (
      <div
        className={classNames(
          'param-expiries',
          { readonly: this.props.readonly, multiple: this.props.multiple !== false },
          this.props.className,
        )}
      >
        {this.renderValue()}
      </div>
    ) : (
      <div className={this.props.className}>
        <Select
          mode={this.props.multiple === false ? undefined : 'multiple'}
          style={{ width: '100%' }}
          placeholder="Choose"
          value={this.props.value?.filter(it => this.props.options?.includes(it))}
          onChange={(values) => this.onChange?.(values)}
        >
          {this.props.options?.map((option) => (
            <Select.Option key={option} value={option} disabled={this.props.calcDisabled?.(option)}>
              {option}
            </Select.Option>
          ))}
        </Select>
      </div>
    );
  }
}
